module.exports = __webpack_public_path__ + "static/media/motoboy_nafil.25ce662d.jpg";